import { NgModule } from '@angular/core';
import { Route } from '@angular/router';

@NgModule({
    imports: [],
    exports: [],
    providers: [],
})
export class LogoutPageProxyModule {
    static defineRoute(path: string): Route {
        return {
            path,
            loadChildren: () =>
                import('app/shared/routing-proxies/logout-page.lazy.module').then(
                    (m) => m.LogoutPageLazyLoadedModule,
                ),
        };
    }
}
